export default "__VITE_ASSET__1707bd72__"